/** Legacy fake URL previously used as img src when a product had no photo. */
export const LEGACY_PLACEHOLDER_IMAGE = '/api/placeholder/600/400';

export const isUsableProductImage = (value?: string | null): value is string =>
  Boolean(value && value.trim() && value !== LEGACY_PLACEHOLDER_IMAGE);
